import React from 'react';
import {t} from '@lingui/core/macro';

import FiltersModal from 'shared/ui/Modal/FiltersModal/FiltersModal';
import {FILTERS_KEPT_NONE} from 'shared/lib/filterHelper';

import DomainIncidentsFiltersFormHandler from './DomainIncidentsFiltersFormHandler';

interface IDomainIncidentsFiltersModalProps {
    open: boolean,
    handleClose: () => void;
}

const DomainIncidentsFiltersModal: React.FC<IDomainIncidentsFiltersModalProps> = ({open, handleClose}) => (
    <FiltersModal header={t`Фильтры`} open={open} handleClose={handleClose} keepParams={FILTERS_KEPT_NONE}>
        <DomainIncidentsFiltersFormHandler
            onSuccess={handleClose}
            handleClose={handleClose}
        />
    </FiltersModal>
);

export default DomainIncidentsFiltersModal;
